var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.376,
    height: 16,
    viewBox: "0 0 14.376 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(-3.15 -2.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2719",
    "data-name": "Group 2719",
    transform: "translate(3.15 2.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M16.835,20.4a.69.69,0,0,1-.69-.69V18.089a2.561,2.561,0,0,0-2.558-2.558h-6.5a2.561,2.561,0,0,0-2.558,2.558v1.624a.69.69,0,0,1-1.381,0V18.089A3.944,3.944,0,0,1,7.089,14.15h6.5a3.944,3.944,0,0,1,3.939,3.939v1.624A.69.69,0,0,1,16.835,20.4Z",
    transform: "translate(-3.15 -4.404)",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    d: "M3.089-.85A3.939,3.939,0,1,1-.85,3.089,3.944,3.944,0,0,1,3.089-.85Zm0,6.5A2.558,2.558,0,1,0,.531,3.089,2.561,2.561,0,0,0,3.089,5.647Z",
    transform: "translate(4.099 0.85)",
    fill: "#95a7c6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyUser);
export default __webpack_public_path__ + "static/media/grey-user.c13cd7e5a98c889db44ede34d50e3c32.svg";
export { ForwardRef as ReactComponent };